import React, { useCallback, useEffect, useRef } from 'react';
import imgURL from '../../lib/imgURL';
import './style.scss';
import { ACCESS_TEST_CREDENTIALS_REDIRECT_KEY, UiRoutes, USER_VERIFICATION_SCREENS_CONSTANTS } from 'lib/constants';
import parse from 'html-react-parser';
import { useDispatch, useSelector } from 'react-redux';
import { clearToggleSelfServeAction, toggleSelfServeAction } from 'redux/actions/onboarding';
import notify from 'lib/notifiy';
import useRedirect from '../../hooks/useRedirect';

const TestEnvLabel = (): JSX.Element => {
  const dispatch = useDispatch();
  const { push } = useRedirect();
  const shouldHandleToggleResponse = useRef(false);
  const labels = USER_VERIFICATION_SCREENS_CONSTANTS.labels;
  // TODO: Remove this after the env toggle is implemented
  const isLive = useSelector(
  (state: any) => state.loginReducer.loginState.isLiveMerchant
);
 const selectedEnv: 'LIVE' | 'TEST' = isLive ? 'LIVE' : 'TEST';

    const {
    isSuccess,
    isFailure,
    errorMessage,
  } = useSelector((state: any) => state?.onboardingReducer?.toggleEnvState);

  useEffect(() => {
    const shouldRedirectToSettings = window.sessionStorage.getItem(ACCESS_TEST_CREDENTIALS_REDIRECT_KEY) === 'true';
    if (!shouldHandleToggleResponse.current && !shouldRedirectToSettings) return;

    if (isSuccess) {
       notify(
        {
        type: 'success',
        message: `Toggled to ${selectedEnv} mode!`,
        description:''
        }
      );
      shouldHandleToggleResponse.current = false;
      window.sessionStorage.removeItem(ACCESS_TEST_CREDENTIALS_REDIRECT_KEY);
      push(shouldRedirectToSettings ? UiRoutes.EDGE_SETTINGS : "/");
      dispatch(clearToggleSelfServeAction());
    } else if (isFailure) {
     
      notify({
        type: 'error',
        message: errorMessage || 'Failed to switch environment',
        description: ''
      });
       shouldHandleToggleResponse.current = false;
       window.sessionStorage.removeItem(ACCESS_TEST_CREDENTIALS_REDIRECT_KEY);
       dispatch(clearToggleSelfServeAction());
    }
  }, [isSuccess, isFailure, errorMessage, selectedEnv, dispatch, push]);

  useEffect(() => {
    return () => {
      if (shouldHandleToggleResponse.current) {
        dispatch(clearToggleSelfServeAction());
      }
    };
  },[dispatch]);

  
  const handleToggle = useCallback(() => {
    shouldHandleToggleResponse.current = true;
    dispatch(toggleSelfServeAction({ env: selectedEnv }));
    push(UiRoutes.EDGE_OVERVIEW);
  }, [dispatch, push, selectedEnv]);

  const isTest = selectedEnv === 'TEST';

  return (
    <div className='test_env-label-box'>
      <div className={`${isTest ? 'test_env' : 'live_env'} test_env-label-container`}>
        <div className='test_env-text-wrapper'>
          <img src={isTest ? imgURL['alert-red'] : imgURL['green-tick']} />{' '}
          <p>{parse(
            isTest
              ? labels.YOU_ARE_IN_TEST_ENV
              : labels.YOU_ARE_IN_LIVE_ENV
          )}</p>
        </div>
        <div className='test_env-btn-wrapper'>
          <div className='test_env-btn-container'>
            <div
              className={`${
                isTest ? 'test_env-test-btn-color' : ''
              } test_env-test-btn`}
               onClick={() => !isTest && handleToggle()}
                style={{ cursor: isTest ? 'not-allowed' : 'pointer' }}
            >
              {labels.TEST_MODE}
            </div>
            <div
              className={`${
                !isTest ? 'test_env-live-btn-color' : ''
              } test_env-live-btn`}
              onClick={() => isTest && handleToggle()}
            style={{ cursor: !isTest ? 'not-allowed' : 'pointer' }}
            >
              {labels.LIVE_MODE}
            </div>
            <div className='test_env-diamond'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestEnvLabel;
